// @flow
import React, { type Node, createContext, useState } from 'react';

import { Spinner } from './Spinner';

type SpinnerContextType = {
  isVisible: boolean,
  showSpinner: Function,
  hideSpinner: Function,
};

export const SpinnerContext = createContext<SpinnerContextType>({
  isVisible: false,
  showSpinner: () => {},
  hideSpinner: () => {},
});

type Props = {
  children: Node,
};

export const SpinnerProvider = ({
  children,
}: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const showSpinner = () => {
    setIsVisible(true);
  };

  const hideSpinner = () => {
    setIsVisible(false);
  };

  return (
    <SpinnerContext.Provider
      value={{
        isVisible,
        showSpinner,
        hideSpinner,
      }}
    >
      {isVisible && (
        <Spinner />
      )}
      {children}
    </SpinnerContext.Provider>
  );
};
